import { createActions, createReducer } from 'reduxsauce';

export { default as thunks } from './thunks';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	invoice   : {},
	hash      : '',
	step      : 1,
	receipt   : {},
	inputData : {
		sendEmailReceipt : true,
	},
	loaders : {
		invoice           : false,
		paymentInfoButton : '',
	},
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions({
	receiveInvoice : ['invoice', 'hash'],
	updateData     : ['property', 'value'],
	updateStep     : ['value'],
	setLoading     : ['property', 'value'],
	resetQuickPay  : null,
	receiveReceipt : ['receipt'],
}, { prefix : '@quickpay/' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.RECEIVE_INVOICE] : (state, { invoice, hash }) => ({
		...state,
		invoice,
		hash,
	}),

	[Types.UPDATE_STEP] : (state, { value }) => ({
		...state,
		step : value,
	}),

	[Types.UPDATE_DATA] : (state, { property, value }) => ({
		...state,
		inputData : {
			...state.inputData,
			[property] : value,
		},
	}),

	[Types.SET_LOADING] : (state, { property, value }) => ({
		...state,
		loaders : {
			...state.loaders,
			[property] : value,
		},
	}),

	[Types.RESET_QUICK_PAY] : () => ({
		...INITIAL_STATE,
	}),

	[Types.RECEIVE_RECEIPT] : (state, { receipt }) => ({
		...state,
		receipt,
	}),
});

export default Creators;
